import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import VueMarkdown from 'vue-markdown-render';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MarkdownFormatted',
    props: {
        source: null
    },
    setup(__props) {
        const props = __props;
        const renderOptions = {
            html: true,
            typographer: true,
            breaks: true,
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(VueMarkdown), {
                source: props.source,
                options: renderOptions
            }, null, 8, ["source"]));
        };
    }
});
